<template>
  <b-form-group :label="$t('fuelStock.fields.fuelType')" label-for="fuelType">
    <b-form-select
      id="fuelType"
      :placeholder="$t('fuelStock.fields.fuelTypeTooltip')"
      v-model="compValue"
      :disabled="readonly"
    >
      <option :value="null"></option>
      <option :value="1">
        {{ $t("fuelStock.fields.fuelTypeDieselComum") }}
      </option>
      <option :value="5">
        {{ $t("fuelStock.fields.fuelTypeDieselS10") }}
      </option>
      <option :value="2">
        {{ $t("fuelStock.fields.fuelTypeGasolina") }}
      </option>
      <option :value="3">
        {{ $t("fuelStock.fields.fuelTypeEtanol") }}
      </option>
      <option :value="4">
        {{ $t("fuelStock.fields.fuelTypeArla") }}
      </option>
      <option :value="6">
        {{ $t("fuelStock.fields.fuelTypeAVGAS") }}
      </option>
    </b-form-select>
    <span class="text-danger" v-if="modelstate['FuelType']">
      {{ modelstate["FuelType"][0] }}
    </span>
  </b-form-group>
</template>

<script>
export default {
  name: "FuelTypeDropdown",
  props: {
    fuelTypeId: {
      type: Number,
      description: "ID do tipo de abastecimento",
      default: null
    },
    readonly: {
      type: Boolean,
      description: "Apenas leitura",
      default: false
    },
    modelstate: {
      type: Object,
      description: "Estado do salvamento",
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    compValue: {
      get: function() {
        return this.fuelTypeId;
      },
      set: function(newValue) {
        let selected = newValue;
        this.$emit("update:fuelTypeId", parseInt(newValue));
      }
    }
  },
  methods: {}
};
</script>
